export const FileNameSplitter = '.';
